/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  Competition,
  CompetitionBrowseScope,
  CompetitionBrowseSort,
  CompetitionEligibilityCheckResponse,
  CompetitionEntryFilter,
  CompetitionStatsResponse,
  CompetitionType,
  CreateCompetitionBody,
  DeleteCompetitionResponse,
  GetCompetitionBrowseResponse,
  GetCompetitionItemsResponse,
  GetCompetitionVisibilityResponse,
  GetCompetitionsResponse,
  NormalizedCompetitionStatus,
  PaidEntryEligibilityResponse,
  PayCompetitionBody,
  PayCompetitionResponse,
  UpdateCompetitionBody,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CompetitionFromJSON,
    CompetitionToJSON,
    CompetitionBrowseScopeFromJSON,
    CompetitionBrowseScopeToJSON,
    CompetitionBrowseSortFromJSON,
    CompetitionBrowseSortToJSON,
    CompetitionEligibilityCheckResponseFromJSON,
    CompetitionEligibilityCheckResponseToJSON,
    CompetitionEntryFilterFromJSON,
    CompetitionEntryFilterToJSON,
    CompetitionStatsResponseFromJSON,
    CompetitionStatsResponseToJSON,
    CompetitionTypeFromJSON,
    CompetitionTypeToJSON,
    CreateCompetitionBodyFromJSON,
    CreateCompetitionBodyToJSON,
    DeleteCompetitionResponseFromJSON,
    DeleteCompetitionResponseToJSON,
    GetCompetitionBrowseResponseFromJSON,
    GetCompetitionBrowseResponseToJSON,
    GetCompetitionItemsResponseFromJSON,
    GetCompetitionItemsResponseToJSON,
    GetCompetitionVisibilityResponseFromJSON,
    GetCompetitionVisibilityResponseToJSON,
    GetCompetitionsResponseFromJSON,
    GetCompetitionsResponseToJSON,
    NormalizedCompetitionStatusFromJSON,
    NormalizedCompetitionStatusToJSON,
    PaidEntryEligibilityResponseFromJSON,
    PaidEntryEligibilityResponseToJSON,
    PayCompetitionBodyFromJSON,
    PayCompetitionBodyToJSON,
    PayCompetitionResponseFromJSON,
    PayCompetitionResponseToJSON,
    UpdateCompetitionBodyFromJSON,
    UpdateCompetitionBodyToJSON,
} from '../models/index';

export interface CreateCompetitionsRequest {
    createCompetitionBody?: CreateCompetitionBody;
}

export interface CreateCompetitionsIdEligibilityCheckRequest {
    id: string;
    type: CreateCompetitionsIdEligibilityCheckTypeEnum;
    body: object;
}

export interface CreateCompetitionsPayRequest {
    payCompetitionBody: PayCompetitionBody;
}

export interface DeleteCompetitionsIdRequest {
    id: string;
}

export interface GetCompetitionBrowseRequest {
    type?: Array<CompetitionType>;
    status?: Array<NormalizedCompetitionStatus>;
    gameId?: string;
    entry?: CompetitionEntryFilter;
    search?: string;
    sort?: CompetitionBrowseSort;
    scope?: CompetitionBrowseScope;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetCompetitionsRequest {
    limit?: number;
    offset?: number;
    status?: string;
    search?: string;
}

export interface GetCompetitionsIdRequest {
    id: string;
}

export interface GetCompetitionsIdItemsRequest {
    id: string;
    type?: CompetitionType;
    activeOnly?: GetCompetitionsIdItemsActiveOnlyEnum;
    limit?: number;
    offset?: number;
}

export interface GetCompetitionsVerifyPaymentRequest {
    type: GetCompetitionsVerifyPaymentTypeEnum;
    competitionId: string;
    participantId: string;
    paymentIntent?: string;
    redirectStatus?: GetCompetitionsVerifyPaymentRedirectStatusEnum;
}

export interface UpdateCompetitionsIdRequest {
    id: string;
    updateCompetitionBody?: UpdateCompetitionBody;
}

/**
 * CompetitionsApi - interface
 * 
 * @export
 * @interface CompetitionsApiInterface
 */
export interface CompetitionsApiInterface {
    /**
     * Creates a new competition
     * @param {CreateCompetitionBody} [createCompetitionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApiInterface
     */
    createCompetitionsRaw(requestParameters: CreateCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Competition>>;

    /**
     * Creates a new competition
     */
    createCompetitions(requestParameters: CreateCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Competition>;

    /**
     * Evaluate whether the requesting user can enter this competition WITHOUT consuming entry. Runs the pre-match eligibility chain and returns a structured result. Used by the web client to enable or disable the \"Enter\" button before the player clicks it. Two checks are live: a minimum age of 18 on any competition that costs money to enter, and the CONTEST jurisdiction policy. A free competition that configures no age bounds of its own passes every user. When `allowed` is false, branch on `failedCheck` — `dateOfBirthMissing` means the age is simply unknown and is answerable by asking the player for a date of birth, unlike `minimumAge`, which means they are outside the allowed range.
     * @param {string} id Competition-tier document id (LeaderboardCompetition / Tournament / Ladder / League / CompetitionChallenge).
     * @param {'leaderboard' | 'tournament' | 'ladder' | 'league' | 'challenge'} type Competition tier — tells the route which model collection to load the id from. Required because the tiers live in separate Mongo collections with no shared discriminator. Accepted values: leaderboard, tournament, ladder, league, challenge.
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApiInterface
     */
    createCompetitionsIdEligibilityCheckRaw(requestParameters: CreateCompetitionsIdEligibilityCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitionEligibilityCheckResponse>>;

    /**
     * Evaluate whether the requesting user can enter this competition WITHOUT consuming entry. Runs the pre-match eligibility chain and returns a structured result. Used by the web client to enable or disable the \"Enter\" button before the player clicks it. Two checks are live: a minimum age of 18 on any competition that costs money to enter, and the CONTEST jurisdiction policy. A free competition that configures no age bounds of its own passes every user. When `allowed` is false, branch on `failedCheck` — `dateOfBirthMissing` means the age is simply unknown and is answerable by asking the player for a date of birth, unlike `minimumAge`, which means they are outside the allowed range.
     */
    createCompetitionsIdEligibilityCheck(requestParameters: CreateCompetitionsIdEligibilityCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitionEligibilityCheckResponse>;

    /**
     * Unified payment endpoint for all competition types. Supports both Fuel and USD (Stripe) payments.  **Supported competition types:** - tournament: Team-based tournaments - ladder: Ranked ladder competitions - league: League competitions  **Note:** Challenges only support Fuel and are handled via /competition-challenges/{id}/join  **For USD payments:** If 3DS authentication is required, returns `nextAction` URL. After user completes 3DS, they\'re redirected to /competitions/verify-payment. 
     * @summary Pay entry fee for a competition (unified for all competition types)
     * @param {PayCompetitionBody} payCompetitionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApiInterface
     */
    createCompetitionsPayRaw(requestParameters: CreateCompetitionsPayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PayCompetitionResponse>>;

    /**
     * Unified payment endpoint for all competition types. Supports both Fuel and USD (Stripe) payments.  **Supported competition types:** - tournament: Team-based tournaments - ladder: Ranked ladder competitions - league: League competitions  **Note:** Challenges only support Fuel and are handled via /competition-challenges/{id}/join  **For USD payments:** If 3DS authentication is required, returns `nextAction` URL. After user completes 3DS, they\'re redirected to /competitions/verify-payment. 
     * Pay entry fee for a competition (unified for all competition types)
     */
    createCompetitionsPay(requestParameters: CreateCompetitionsPayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PayCompetitionResponse>;

    /**
     * Deletes a competition (only if in DRAFT status)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApiInterface
     */
    deleteCompetitionsIdRaw(requestParameters: DeleteCompetitionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteCompetitionResponse>>;

    /**
     * Deletes a competition (only if in DRAFT status)
     */
    deleteCompetitionsId(requestParameters: DeleteCompetitionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteCompetitionResponse>;

    /**
     * Returns aggregated statistics across all competition types for the admin dashboard. Includes counts for tournaments, leagues, leaderboards, ladders, challenges, hubs, and guilds. Uses efficient MongoDB aggregation pipelines to minimize database load. 
     * @summary Get aggregated competition statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApiInterface
     */
    getAdminCompetitionStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitionStatsResponse>>;

    /**
     * Returns aggregated statistics across all competition types for the admin dashboard. Includes counts for tournaments, leagues, leaderboards, ladders, challenges, hubs, and guilds. Uses efficient MongoDB aggregation pipelines to minimize database load. 
     * Get aggregated competition statistics
     */
    getAdminCompetitionStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitionStatsResponse>;

    /**
     * Unified browse feed across every competition type. Returns one page of competition cards plus facet counts for the filter rail, computed in the same pass so counts always agree with the grid. Public — no authentication. DRAFT, PAUSED and CANCELLED competitions are never returned, whatever is requested. COMPLETED is excluded unless explicitly requested via `status`. Note that `offset` is a zero-based PAGE index (skip = offset × limit), matching this backend\'s shared getPaginationInfo convention — not a record offset. A page past the end is clamped to the last page rather than erroring. 
     * @param {Array<CompetitionType>} [type] Restrict to these competition types. Repeatable. Types disabled in CompetitionVisibility are always excluded.
     * @param {Array<NormalizedCompetitionStatus>} [status] Restrict to these normalized statuses. Repeatable. Omit for the default live feed (UPCOMING, OPEN and LIVE). DRAFT, PAUSED and CANCELLED are rejected from the feed even when named explicitly. COMPLETED means a competition whose RACE has finished, not one whose record is closed — a recurring leaderboard never closes, so asking by its status returned nothing. It is bounded to the last 7 days and a board appears once however many times it ran in them. 
     * @param {string} [gameId] Restrict to one game (OWGame ObjectId).
     * @param {CompetitionEntryFilter} [entry] Filter by entry cost.
     * @param {string} [search] Case-insensitive substring match on competition name.
     * @param {CompetitionBrowseSort} [sort] Sort order. Defaults to ENDING. MY_GAMES floats competitions on games the bearer has recorded play time on above the rest, ordered by soonest-ending within each half; sent without a bearer, or by someone with no play history, it behaves exactly as ENDING. 
     * @param {CompetitionBrowseScope} [scope] ALL (the default) is the public directory. MINE returns only the competitions the bearer is entered in, including occurrences paid for that have not opened yet, and needs a bearer — without one it is a 401. Facet counts narrow with the scope, except &#x60;facets.scope&#x60;, which always carries both figures. 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApiInterface
     */
    getCompetitionBrowseRaw(requestParameters: GetCompetitionBrowseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompetitionBrowseResponse>>;

    /**
     * Unified browse feed across every competition type. Returns one page of competition cards plus facet counts for the filter rail, computed in the same pass so counts always agree with the grid. Public — no authentication. DRAFT, PAUSED and CANCELLED competitions are never returned, whatever is requested. COMPLETED is excluded unless explicitly requested via `status`. Note that `offset` is a zero-based PAGE index (skip = offset × limit), matching this backend\'s shared getPaginationInfo convention — not a record offset. A page past the end is clamped to the last page rather than erroring. 
     */
    getCompetitionBrowse(requestParameters: GetCompetitionBrowseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompetitionBrowseResponse>;

    /**
     * Get visibility settings for all competition types. No authentication required.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApiInterface
     */
    getCompetitionVisibilityRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompetitionVisibilityResponse>>;

    /**
     * Get visibility settings for all competition types. No authentication required.
     */
    getCompetitionVisibility(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompetitionVisibilityResponse>;

    /**
     * Gets a paginated list of competitions
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [status] Filter by competition status (DRAFT, ACTIVE, COMPLETED, CANCELLED)
     * @param {string} [search] Search competitions by name (case-insensitive)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApiInterface
     */
    getCompetitionsRaw(requestParameters: GetCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompetitionsResponse>>;

    /**
     * Gets a paginated list of competitions
     */
    getCompetitions(requestParameters: GetCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompetitionsResponse>;

    /**
     * Whether the requesting viewer may enter PAID competitions from their current location. Answers the part of eligibility that does not vary by board — location and age — so a page showing many entry CTAs can ask once rather than per competition. Board-specific rules (the Connecticut and Maryland prize caps) are NOT evaluated here; use the per-competition eligibility route for those. A missing date of birth does not block: only a known disqualifying age does.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApiInterface
     */
    getCompetitionsEligibilityPaidEntryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaidEntryEligibilityResponse>>;

    /**
     * Whether the requesting viewer may enter PAID competitions from their current location. Answers the part of eligibility that does not vary by board — location and age — so a page showing many entry CTAs can ask once rather than per competition. Board-specific rules (the Connecticut and Maryland prize caps) are NOT evaluated here; use the per-competition eligibility route for those. A missing date of birth does not block: only a known disqualifying age does.
     */
    getCompetitionsEligibilityPaidEntry(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaidEntryEligibilityResponse>;

    /**
     * Gets a single competition by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApiInterface
     */
    getCompetitionsIdRaw(requestParameters: GetCompetitionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Competition>>;

    /**
     * Gets a single competition by ID
     */
    getCompetitionsId(requestParameters: GetCompetitionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Competition>;

    /**
     * Resolve the competitions inside an umbrella. Host-agnostic — any surface holding a competition id can read it.
     * @param {string} id Competition umbrella id
     * @param {CompetitionType} [type] Filter by competition type
     * @param {'true'} [activeOnly] Only return active/live competitions
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApiInterface
     */
    getCompetitionsIdItemsRaw(requestParameters: GetCompetitionsIdItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompetitionItemsResponse>>;

    /**
     * Resolve the competitions inside an umbrella. Host-agnostic — any surface holding a competition id can read it.
     */
    getCompetitionsIdItems(requestParameters: GetCompetitionsIdItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompetitionItemsResponse>;

    /**
     * Callback endpoint for Stripe 3DS authentication flow. After user completes 3DS verification, Stripe redirects here. This endpoint verifies the payment and redirects to frontend.  **Supported competition types:** - tournament: Team-based tournaments - ladder: Ranked ladder competitions - league: League competitions  **Note:** Challenges only support Fuel payments (no 3DS). This is a redirect endpoint, not a JSON API. 
     * @summary Verify Stripe 3DS payment callback (unified for all competition types)
     * @param {'tournament' | 'ladder' | 'league'} type Competition type (challenges not supported - Fuel only)
     * @param {string} competitionId Competition ID
     * @param {string} participantId Participant/Team ID
     * @param {string} [paymentIntent] Stripe Payment Intent ID (provided by Stripe)
     * @param {'succeeded' | 'failed'} [redirectStatus] Stripe redirect status (succeeded/failed)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApiInterface
     */
    getCompetitionsVerifyPaymentRaw(requestParameters: GetCompetitionsVerifyPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Callback endpoint for Stripe 3DS authentication flow. After user completes 3DS verification, Stripe redirects here. This endpoint verifies the payment and redirects to frontend.  **Supported competition types:** - tournament: Team-based tournaments - ladder: Ranked ladder competitions - league: League competitions  **Note:** Challenges only support Fuel payments (no 3DS). This is a redirect endpoint, not a JSON API. 
     * Verify Stripe 3DS payment callback (unified for all competition types)
     */
    getCompetitionsVerifyPayment(requestParameters: GetCompetitionsVerifyPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Updates a competition
     * @param {string} id 
     * @param {UpdateCompetitionBody} [updateCompetitionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitionsApiInterface
     */
    updateCompetitionsIdRaw(requestParameters: UpdateCompetitionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Competition>>;

    /**
     * Updates a competition
     */
    updateCompetitionsId(requestParameters: UpdateCompetitionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Competition>;

}

/**
 * 
 */
export class CompetitionsApi extends runtime.BaseAPI implements CompetitionsApiInterface {

    /**
     * Creates a new competition
     */
    async createCompetitionsRaw(requestParameters: CreateCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Competition>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/competitions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCompetitionBodyToJSON(requestParameters['createCompetitionBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionFromJSON(jsonValue));
    }

    /**
     * Creates a new competition
     */
    async createCompetitions(requestParameters: CreateCompetitionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Competition> {
        const response = await this.createCompetitionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Evaluate whether the requesting user can enter this competition WITHOUT consuming entry. Runs the pre-match eligibility chain and returns a structured result. Used by the web client to enable or disable the \"Enter\" button before the player clicks it. Two checks are live: a minimum age of 18 on any competition that costs money to enter, and the CONTEST jurisdiction policy. A free competition that configures no age bounds of its own passes every user. When `allowed` is false, branch on `failedCheck` — `dateOfBirthMissing` means the age is simply unknown and is answerable by asking the player for a date of birth, unlike `minimumAge`, which means they are outside the allowed range.
     */
    async createCompetitionsIdEligibilityCheckRaw(requestParameters: CreateCompetitionsIdEligibilityCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitionEligibilityCheckResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createCompetitionsIdEligibilityCheck().'
            );
        }

        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling createCompetitionsIdEligibilityCheck().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling createCompetitionsIdEligibilityCheck().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/competitions/{id}/eligibility-check`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionEligibilityCheckResponseFromJSON(jsonValue));
    }

    /**
     * Evaluate whether the requesting user can enter this competition WITHOUT consuming entry. Runs the pre-match eligibility chain and returns a structured result. Used by the web client to enable or disable the \"Enter\" button before the player clicks it. Two checks are live: a minimum age of 18 on any competition that costs money to enter, and the CONTEST jurisdiction policy. A free competition that configures no age bounds of its own passes every user. When `allowed` is false, branch on `failedCheck` — `dateOfBirthMissing` means the age is simply unknown and is answerable by asking the player for a date of birth, unlike `minimumAge`, which means they are outside the allowed range.
     */
    async createCompetitionsIdEligibilityCheck(requestParameters: CreateCompetitionsIdEligibilityCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitionEligibilityCheckResponse> {
        const response = await this.createCompetitionsIdEligibilityCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unified payment endpoint for all competition types. Supports both Fuel and USD (Stripe) payments.  **Supported competition types:** - tournament: Team-based tournaments - ladder: Ranked ladder competitions - league: League competitions  **Note:** Challenges only support Fuel and are handled via /competition-challenges/{id}/join  **For USD payments:** If 3DS authentication is required, returns `nextAction` URL. After user completes 3DS, they\'re redirected to /competitions/verify-payment. 
     * Pay entry fee for a competition (unified for all competition types)
     */
    async createCompetitionsPayRaw(requestParameters: CreateCompetitionsPayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PayCompetitionResponse>> {
        if (requestParameters['payCompetitionBody'] == null) {
            throw new runtime.RequiredError(
                'payCompetitionBody',
                'Required parameter "payCompetitionBody" was null or undefined when calling createCompetitionsPay().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/competitions/pay`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PayCompetitionBodyToJSON(requestParameters['payCompetitionBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PayCompetitionResponseFromJSON(jsonValue));
    }

    /**
     * Unified payment endpoint for all competition types. Supports both Fuel and USD (Stripe) payments.  **Supported competition types:** - tournament: Team-based tournaments - ladder: Ranked ladder competitions - league: League competitions  **Note:** Challenges only support Fuel and are handled via /competition-challenges/{id}/join  **For USD payments:** If 3DS authentication is required, returns `nextAction` URL. After user completes 3DS, they\'re redirected to /competitions/verify-payment. 
     * Pay entry fee for a competition (unified for all competition types)
     */
    async createCompetitionsPay(requestParameters: CreateCompetitionsPayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PayCompetitionResponse> {
        const response = await this.createCompetitionsPayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a competition (only if in DRAFT status)
     */
    async deleteCompetitionsIdRaw(requestParameters: DeleteCompetitionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteCompetitionResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteCompetitionsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/competitions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteCompetitionResponseFromJSON(jsonValue));
    }

    /**
     * Deletes a competition (only if in DRAFT status)
     */
    async deleteCompetitionsId(requestParameters: DeleteCompetitionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteCompetitionResponse> {
        const response = await this.deleteCompetitionsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns aggregated statistics across all competition types for the admin dashboard. Includes counts for tournaments, leagues, leaderboards, ladders, challenges, hubs, and guilds. Uses efficient MongoDB aggregation pipelines to minimize database load. 
     * Get aggregated competition statistics
     */
    async getAdminCompetitionStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitionStatsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/competition-stats`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionStatsResponseFromJSON(jsonValue));
    }

    /**
     * Returns aggregated statistics across all competition types for the admin dashboard. Includes counts for tournaments, leagues, leaderboards, ladders, challenges, hubs, and guilds. Uses efficient MongoDB aggregation pipelines to minimize database load. 
     * Get aggregated competition statistics
     */
    async getAdminCompetitionStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitionStatsResponse> {
        const response = await this.getAdminCompetitionStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Unified browse feed across every competition type. Returns one page of competition cards plus facet counts for the filter rail, computed in the same pass so counts always agree with the grid. Public — no authentication. DRAFT, PAUSED and CANCELLED competitions are never returned, whatever is requested. COMPLETED is excluded unless explicitly requested via `status`. Note that `offset` is a zero-based PAGE index (skip = offset × limit), matching this backend\'s shared getPaginationInfo convention — not a record offset. A page past the end is clamped to the last page rather than erroring. 
     */
    async getCompetitionBrowseRaw(requestParameters: GetCompetitionBrowseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompetitionBrowseResponse>> {
        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['entry'] != null) {
            queryParameters['entry'] = requestParameters['entry'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['scope'] != null) {
            queryParameters['scope'] = requestParameters['scope'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/competition-browse`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompetitionBrowseResponseFromJSON(jsonValue));
    }

    /**
     * Unified browse feed across every competition type. Returns one page of competition cards plus facet counts for the filter rail, computed in the same pass so counts always agree with the grid. Public — no authentication. DRAFT, PAUSED and CANCELLED competitions are never returned, whatever is requested. COMPLETED is excluded unless explicitly requested via `status`. Note that `offset` is a zero-based PAGE index (skip = offset × limit), matching this backend\'s shared getPaginationInfo convention — not a record offset. A page past the end is clamped to the last page rather than erroring. 
     */
    async getCompetitionBrowse(requestParameters: GetCompetitionBrowseRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompetitionBrowseResponse> {
        const response = await this.getCompetitionBrowseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get visibility settings for all competition types. No authentication required.
     */
    async getCompetitionVisibilityRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompetitionVisibilityResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/competition-visibility`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompetitionVisibilityResponseFromJSON(jsonValue));
    }

    /**
     * Get visibility settings for all competition types. No authentication required.
     */
    async getCompetitionVisibility(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompetitionVisibilityResponse> {
        const response = await this.getCompetitionVisibilityRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets a paginated list of competitions
     */
    async getCompetitionsRaw(requestParameters: GetCompetitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompetitionsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/competitions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompetitionsResponseFromJSON(jsonValue));
    }

    /**
     * Gets a paginated list of competitions
     */
    async getCompetitions(requestParameters: GetCompetitionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompetitionsResponse> {
        const response = await this.getCompetitionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Whether the requesting viewer may enter PAID competitions from their current location. Answers the part of eligibility that does not vary by board — location and age — so a page showing many entry CTAs can ask once rather than per competition. Board-specific rules (the Connecticut and Maryland prize caps) are NOT evaluated here; use the per-competition eligibility route for those. A missing date of birth does not block: only a known disqualifying age does.
     */
    async getCompetitionsEligibilityPaidEntryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaidEntryEligibilityResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/competitions/eligibility/paid-entry`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaidEntryEligibilityResponseFromJSON(jsonValue));
    }

    /**
     * Whether the requesting viewer may enter PAID competitions from their current location. Answers the part of eligibility that does not vary by board — location and age — so a page showing many entry CTAs can ask once rather than per competition. Board-specific rules (the Connecticut and Maryland prize caps) are NOT evaluated here; use the per-competition eligibility route for those. A missing date of birth does not block: only a known disqualifying age does.
     */
    async getCompetitionsEligibilityPaidEntry(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaidEntryEligibilityResponse> {
        const response = await this.getCompetitionsEligibilityPaidEntryRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets a single competition by ID
     */
    async getCompetitionsIdRaw(requestParameters: GetCompetitionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Competition>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCompetitionsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/competitions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionFromJSON(jsonValue));
    }

    /**
     * Gets a single competition by ID
     */
    async getCompetitionsId(requestParameters: GetCompetitionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Competition> {
        const response = await this.getCompetitionsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve the competitions inside an umbrella. Host-agnostic — any surface holding a competition id can read it.
     */
    async getCompetitionsIdItemsRaw(requestParameters: GetCompetitionsIdItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompetitionItemsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCompetitionsIdItems().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['activeOnly'] != null) {
            queryParameters['activeOnly'] = requestParameters['activeOnly'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/competitions/{id}/items`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompetitionItemsResponseFromJSON(jsonValue));
    }

    /**
     * Resolve the competitions inside an umbrella. Host-agnostic — any surface holding a competition id can read it.
     */
    async getCompetitionsIdItems(requestParameters: GetCompetitionsIdItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompetitionItemsResponse> {
        const response = await this.getCompetitionsIdItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Callback endpoint for Stripe 3DS authentication flow. After user completes 3DS verification, Stripe redirects here. This endpoint verifies the payment and redirects to frontend.  **Supported competition types:** - tournament: Team-based tournaments - ladder: Ranked ladder competitions - league: League competitions  **Note:** Challenges only support Fuel payments (no 3DS). This is a redirect endpoint, not a JSON API. 
     * Verify Stripe 3DS payment callback (unified for all competition types)
     */
    async getCompetitionsVerifyPaymentRaw(requestParameters: GetCompetitionsVerifyPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling getCompetitionsVerifyPayment().'
            );
        }

        if (requestParameters['competitionId'] == null) {
            throw new runtime.RequiredError(
                'competitionId',
                'Required parameter "competitionId" was null or undefined when calling getCompetitionsVerifyPayment().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling getCompetitionsVerifyPayment().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['competitionId'] != null) {
            queryParameters['competitionId'] = requestParameters['competitionId'];
        }

        if (requestParameters['participantId'] != null) {
            queryParameters['participantId'] = requestParameters['participantId'];
        }

        if (requestParameters['paymentIntent'] != null) {
            queryParameters['payment_intent'] = requestParameters['paymentIntent'];
        }

        if (requestParameters['redirectStatus'] != null) {
            queryParameters['redirect_status'] = requestParameters['redirectStatus'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/competitions/verify-payment`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Callback endpoint for Stripe 3DS authentication flow. After user completes 3DS verification, Stripe redirects here. This endpoint verifies the payment and redirects to frontend.  **Supported competition types:** - tournament: Team-based tournaments - ladder: Ranked ladder competitions - league: League competitions  **Note:** Challenges only support Fuel payments (no 3DS). This is a redirect endpoint, not a JSON API. 
     * Verify Stripe 3DS payment callback (unified for all competition types)
     */
    async getCompetitionsVerifyPayment(requestParameters: GetCompetitionsVerifyPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getCompetitionsVerifyPaymentRaw(requestParameters, initOverrides);
    }

    /**
     * Updates a competition
     */
    async updateCompetitionsIdRaw(requestParameters: UpdateCompetitionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Competition>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCompetitionsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/competitions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCompetitionBodyToJSON(requestParameters['updateCompetitionBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetitionFromJSON(jsonValue));
    }

    /**
     * Updates a competition
     */
    async updateCompetitionsId(requestParameters: UpdateCompetitionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Competition> {
        const response = await this.updateCompetitionsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreateCompetitionsIdEligibilityCheckTypeEnum = {
    Leaderboard: 'leaderboard',
    Tournament: 'tournament',
    Ladder: 'ladder',
    League: 'league',
    Challenge: 'challenge'
} as const;
export type CreateCompetitionsIdEligibilityCheckTypeEnum = typeof CreateCompetitionsIdEligibilityCheckTypeEnum[keyof typeof CreateCompetitionsIdEligibilityCheckTypeEnum];
/**
 * @export
 */
export const GetCompetitionsIdItemsActiveOnlyEnum = {
    True: 'true'
} as const;
export type GetCompetitionsIdItemsActiveOnlyEnum = typeof GetCompetitionsIdItemsActiveOnlyEnum[keyof typeof GetCompetitionsIdItemsActiveOnlyEnum];
/**
 * @export
 */
export const GetCompetitionsVerifyPaymentTypeEnum = {
    Tournament: 'tournament',
    Ladder: 'ladder',
    League: 'league'
} as const;
export type GetCompetitionsVerifyPaymentTypeEnum = typeof GetCompetitionsVerifyPaymentTypeEnum[keyof typeof GetCompetitionsVerifyPaymentTypeEnum];
/**
 * @export
 */
export const GetCompetitionsVerifyPaymentRedirectStatusEnum = {
    Succeeded: 'succeeded',
    Failed: 'failed'
} as const;
export type GetCompetitionsVerifyPaymentRedirectStatusEnum = typeof GetCompetitionsVerifyPaymentRedirectStatusEnum[keyof typeof GetCompetitionsVerifyPaymentRedirectStatusEnum];
